var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluses3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 48V24.9976M25.5 24.9976L5.17667 13.4965M25.5 24.9976L45.8233 13.4965M15 7.21682L36 19.063M23.1667 47.3789C23.8761 47.7827 24.6808 47.9953 25.5 47.9953C26.3192 47.9953 27.1239 47.7827 27.8333 47.3789L44.1667 38.178C44.8754 37.7746 45.464 37.1946 45.8736 36.4961C46.2831 35.7977 46.4992 35.0053 46.5 34.1986V15.7967C46.4992 14.9899 46.2831 14.1976 45.8736 13.4991C45.464 12.8007 44.8754 12.2207 44.1667 11.8173L27.8333 2.61635C27.1239 2.21257 26.3192 2 25.5 2C24.6808 2 23.8761 2.21257 23.1667 2.61635L6.83333 11.8173C6.12461 12.2207 5.53595 12.8007 5.12641 13.4991C4.71687 14.1976 4.50084 14.9899 4.5 15.7967V34.1986C4.50084 35.0053 4.71687 35.7977 5.12641 36.4961C5.53595 37.1946 6.12461 37.7746 6.83333 38.178L23.1667 47.3789Z",
    stroke: "#194383",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluses3);
export default __webpack_public_path__ + "static/media/pluses3.8413435e401513cc6e17a4f58cff4a36.svg";
export { ForwardRef as ReactComponent };